import { styled } from '@mui/material/styles';
import InputField from '#component/form/input';
import TextAreaField from '#component/form/textarea';
import SelectProject from '#component/form/multiple-select-project';
import DateTimeField from '#component/form/date-time-field';

export const StyledTextField = styled(InputField)(({ theme }) => ({
  marginTop: theme.spacing(),
  marginBottom: theme.spacing()
}));

export const StyledDescriptionField = styled(TextAreaField)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(2),

  '&:focus-visible': {
    outlineColor: '#000'
  },

  '&::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    borderRadius: 10,
    backgroundColor: '#F5F5F5'
  },

  '&::-webkit-scrollbar': {
    width: 8,
    backgroundColor: '#F5F5F5'
  },

  '&::-webkit-scrollbar-thumb': {
    borderRadius: 10,
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
    backgroundColor: '#a0a0a0'
  }
}));

export const ParentProjectField = styled(SelectProject)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    '& span[style*="position: absolute"]': {
      marginTop: '20px',
      textAlign: 'left',
      left: '11px',
      bottom: '5px'
    },
    '& p': {
      marginBottom: '11px'
    }
  }
}));

export const StyledDateField = styled(DateTimeField)(({ theme }) => ({
  marginTop: theme.spacing(),
  marginBottom: theme.spacing()
}));
